module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_10x40-9b325b502db22b69dbf1ec56e76f9ef6.png";